import _get from 'lodash/get';
import { store } from 'store/configureStore';
import axios from 'axios';

export function getNormalErrors(response = {}) {
    const errors = {};
    let error = '';

    if (response.statusText) {
        error = response.statusText;
    }

    response.errors && response.errors.forEach((err) => {
        if (err.field) {
            if (err.messages && Array.isArray(err.messages)) {
                errors[err.field] = _get(err.messages, '[0]', 'error');
            }
        } else if (err.message) {
            error = err.message;
        }
    });

    return {
        errors,
        error,
    };
}

/**
 * 
 * @param {string} message 
 * @param {'success' | 'warning' | 'error'} type 
 * @param {{ autoDismiss?: number }} opts
 */
export function showNotification(message = '', type = 'success', { autoDismiss = 5 } = {}) {
    store.dispatch({
        type: 'ADD_NOTIFICATION',
        notification: {
            title: type.toUpperCase(),
            message: message || type,
            level: type,
            autoDismiss,
        },
    });
}

const helpers = {
    filterSearch(searchArray, searchText, searchFields) {
        const filteredArray = [];

        for (let i = 0; i < searchArray.length; i++) {
            let splitString = '';

            for (let j = 0; j < searchFields.length; j++) {
                if (searchArray[i][searchFields[j]]) {
                    splitString = splitString + ' ' + searchArray[i][searchFields[j]];
                }
            }
            if (splitString.toLowerCase().includes(searchText)) {
                filteredArray.push(searchArray[i]);
            }
        }
        return filteredArray;
    },
    getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    },
    createHashColor() {
        const hex = 'ABCDEF';
        const colorArray = [];

        for (let i = 0; i < 6; i++) {
            colorArray.push(hex.split('')[this.getRandomNumber(0, 6)]);
        }

        return '#' + colorArray.join('');
    },
    createRGBAColor(opacity = 1) {
        return `(${this.getRandomNumber(0, 255)},${this.getRandomNumber(0, 255)},${this.getRandomNumber(0, 255)},${opacity}')')`;
    },
    getSelection(element) {
        let startOffset = 0;
        let endOffset = 0;
        /* get selection of user selection window.getSelection() */
        const range = window.getSelection().getRangeAt(0);
        const preCaretRange = range.cloneRange();

        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.startContainer, range.startOffset);

        startOffset = preCaretRange.toString().length;
        endOffset = startOffset + range.toString().length;

        return {
            start: startOffset,
            end: endOffset,
            string: range.toString(),
        };
    },
    getNextId(items) {
        let nextId = 0;

        items.forEach((item) => {
            if (item.id >= nextId) {
                nextId = item.id;
            }
        });

        return nextId + 1;
    },
    sortByDate(field) {
        return function (a, b) {
            return new Date(b[field]) - new Date(a[field]);
        };
    },
    isDirty() {

    },
    escapeRegExp(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    },

    /**
     * 
     * @param {string} str 
     */
    getUrlFromString(str) {
        const pattern = new RegExp('(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?', 'i'); // fragment locator

        const url = str.match(pattern);

        return url ? url[0] : '';
    },
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    clearLetters(value) {
        return value.replace(/[.,]+/g, '.').replace(/[^.\d]/g, '');
    },

    /**
     * @param {any} user
     * @param {string[]} addEmails 
     * @returns 
     */
    isDevAllowed(user, addEmails = []) {
        if (!user || !user.email) {
            return false;
        }
        return [
            'serhsamiy@gmail.com',
            'qa@shipnext.com',
            'd.kundasov@shipnext.com',
            'a.timotin+qa@shipnext.com',
            'admin@shipnext.com',
            'sergey.s@myco.com',
            'ss@shipnext.com',
            's.semernev@shipnext.com',
            'n.liashenko@shipnext.com',
            'a77shiptest@gmail.com',
            'o.korostin@shipnext.com',
            ...addEmails,
        ].includes(user && user.email.toLowerCase());
    },
    async prepareOneTimeAuthSession(userId) {
        return axios({
            method: 'post',
            url: '/api/v1/auth/prepareOneTimeAuthSession',
            data: {
                userId,
            },
        })
            .then(response => response.data.data);
    },
};

export default helpers;



// WEBPACK FOOTER //
// ./app/helpers/index.js